import React from 'react'
import CourseForm from './CourseForm'

const EditCourse = () => {
  return (
    <>
    <CourseForm action="Edit"/> 
    </>
  )
}

export default EditCourse
